import styled, { css } from "styled-components";

export const fontStyle = css`
	color: var(--main-text-color);
	font-size: 9px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 12px;
		letter-spacing: 0.3px;
	}
	@media (min-width: 1600px) {
		font-size: 16px;
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			color: #ececfb;
			font-size: 10px;
			font-weight: 400;
			line-height: 20px;
			letter-spacing: 0.3px;

			@media (min-width: 768px) {
				font-size: 12px;
				line-height: 12px;
				letter-spacing: 0.3px;
			}
			@media (min-width: 1600px) {
				font-size: 16px;
			}
		`}
`;

export const IconButtonContainer = styled.button`
	display: flex;
	height: 30px;
	min-width: 72px;
	width: min-content;
	justify-content: center;
	align-items: center;
	border-radius: 20px;
	outline: none;
	border: none;
	background: var(--main-gradient);
	cursor: pointer;

	@media (min-width: 1600px) {
		min-width: 120px;
		height: 40px;
	}

	:hover {
		opacity: 0.7;
	}
	svg {
		padding-bottom: 2px;

		@media (min-width: 1600px) {
			width: 65px;
			height: 100%;
		}
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			${fontStyle}
			border-radius: 10px;
			border: 1px solid #1f1f1f;
			background: #0c1011;
		`}
`;

export const OutlineButtonContainer = styled.button`
	display: flex;
	height: 30px;
	min-width: 140px;
	width: max-content;
	justify-content: center;
	align-items: center;
	border-radius: 20px;
	outline: none;
	border: none;
	${() =>
		window.CASINO_FILTER_BUTTON_BORDERED &&
		css`
			border: 1px solid var(--main-text-color);
		`}
	padding: 0px 10px;
	border-radius: 20px;
	background: var(--casino-filter-button-bg);
	${fontStyle}
	transition: transform 0.2s ease-in-out;
	color: var(--main-text-color);
	cursor: pointer;
	font-size: 12px;
	font-weight: 400;

	@media (min-width: 1600px) {
		height: 40px;
		min-width: 200px;
	}
	:hover {
		opacity: 0.7;
	}

	svg {
		margin-right: 5px;
	}

	div {
		min-width: 60px;
		.tvbet-icon {
			margin-left: 6px;
			margin-right: 0;
			width: 44px;

			@media (min-width: 768px) {
				width: 50px;
			}

			@media (min-width: 1600px) {
				width: 60px;
			}
		}
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			${fontStyle}
			border-radius: 10px;
			border: 1px solid #1f1f1f;
			background: #0c1011;
		`}
`;
